module.exports = __webpack_public_path__ + "S.svg?79dd9e0e29d73a3146bf36b33f1cd0e2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/S.svg
// module id = 68
// module chunks = 0